<template>
    <svg id="Layer_1" data-name="Layer 1" fill=""  width="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 437.92 433.88">
        <path fill="currentColor" class="aoe-logo"
            d="M239.16,70.7c.5,1.91-.79,2.2-1.64,3.3-2.4,3.11-26.94,27.91-28.9,28.43l-21.8-2.13c-135.15,2.63-198.54,169.01-93.6,258.51,102.31,87.24,259.03-2.66,238.65-133.35l30.14-30.47c3.14-.08,8.07,36.08,8.31,40.07,8,136.18-130.61,234.26-256.71,179.28C4.29,366.68-30.8,228.22,43.11,133.98c46.24-58.95,123.49-82.86,196.05-63.28Z" />
        <g>
            <path fill="#003300"  class="aoe-logo"
                d="M179.68,185.06l.52-2.2L352.06,11.28c10.36-8.79,19.68-11.99,32.48-4.87,9.67,13.3,37.86,32.2,44.74,45.52,5.06,9.8,2.56,20.65-4.46,28.67l-174.16,173.72-70.98-69.27Z" />
            <path fill="#003300"  class="aoe-logo"
                d="M122.77,311.17c-3.49-3.4-2.92-8.47-2.09-12.87,2.74-14.51,14.26-45.63,19.93-60.39,3.59-9.36,8.13-18.49,14.28-26.42l67.74,67.62c-6.94,6.15-15.42,10.09-23.95,13.47-17.12,6.78-44.52,16.13-62.23,20.36-5.02,1.2-9.3,2.5-13.68-1.77Z" />
        </g>
    </svg>

</template>

<script>
export default {
    name: 'aoeEduLicensingIcon',
}

</script>

